import { render, staticRenderFns } from "./AvantagePro.vue?vue&type=template&id=3cdcae50&scoped=true"
import script from "./AvantagePro.vue?vue&type=script&lang=js"
export * from "./AvantagePro.vue?vue&type=script&lang=js"
import style0 from "./AvantagePro.vue?vue&type=style&index=0&id=3cdcae50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdcae50",
  null
  
)

export default component.exports